import React from "react";

//external components
import PropTypes from "prop-types";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import LocationForm from "../../Locations-form";
import LocationWifiList from "../../Locations-wifi"

function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={{ pt: 0.5, pb: 0.5 }}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};

export default function LocationsTabRoutes({ value, fromTenant , myTenant, fromCompany}) {
  return (
    <>
      <TabPanel value={value} index={0}>
       <LocationForm fromTenant={fromTenant} myTenant={myTenant} fromCompany={fromCompany}/>
      </TabPanel>
      <TabPanel value={value} index={1}>
       <LocationWifiList fromTenant={fromTenant} myTenant={myTenant} fromCompany={fromCompany}/>
      </TabPanel>
    </>
  );
}
